import { InputText, Radio } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import React from 'react';
import { Form } from 'reactstrap';
import { updateMask as updateMaskCash } from '@/helpers/masks/cashNumber';
import { updateMask as updateMaskDate } from '@/helpers/masks/generalDate';
import { FormInputFilterEvent } from '../../types';

interface FilterContentProps {
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
}

export const FilterContentCancelTickets: React.FC<FilterContentProps> = ({
  formData,
  formErrors,
  onChangeFormInput,
}) => {
  const optionFilter = [
    { label: 'Data do Pedido', value: 'orderDate' },
    { label: 'Valor do Pedido', value: 'totalValue' },
    { label: 'Id do Ingresso', value: 'orderItemId' },
    { label: 'Nome da mesa', value: 'itemLabel' },
  ];

  return (
    <div className="filter-modal-content">
      <Form noValidate={true} onSubmit={(e): void => e.preventDefault()}>
        <span className="filter-name">Filtrar por:</span>
        <Radio
          options={optionFilter}
          name="filterSearch"
          style={{ fontSize: '21px' }}
          value={formData[FormInputFilterEvent.filterSearch]}
          onChange={e => onChangeFormInput(FormInputFilterEvent.filterSearch)(e.target.value)}
          error={formErrors.filterSearch && formErrors.filterSearch[0]}
        />
        {formData[FormInputFilterEvent.filterSearch] === 'orderDate' && (
          <>
            <h3 className="filter-status-name">Selecione os Status</h3>
            <InputText
              name="birthDate"
              label="Data do Pedido"
              placeholder="00/00/0000"
              value={updateMaskDate(formData[FormInputFilterEvent.inputSearch])}
              onChange={e => onChangeFormInput(FormInputFilterEvent.inputSearch)(e.target.value)}
              error={formErrors.birthDate && formErrors.birthDate[0]}
            />
          </>
        )}
        {formData[FormInputFilterEvent.filterSearch] === 'orderItemId' && (
          <InputText
            name="inputSearch"
            label="Id do Ingresso"
            placeholder={'Digite o id'}
            value={formData[FormInputFilterEvent.inputSearch]}
            onChange={e => onChangeFormInput(FormInputFilterEvent.inputSearch)(e.target.value)}
            error={formErrors.inputSearch && formErrors.inputSearch[0]}
          />
        )}
        {formData[FormInputFilterEvent.filterSearch] === 'totalValue' && (
          <InputText
            name="valueFee"
            label="Valor do Pedido"
            placeholder="R$40,00"
            value={
              formData[FormInputFilterEvent.inputSearch] === '0'
                ? updateMaskCash(formData[FormInputFilterEvent.inputSearch])
                : formData[FormInputFilterEvent.inputSearch]
            }
            onChange={e => onChangeFormInput(FormInputFilterEvent.inputSearch)(e.target.value)}
            error={formErrors.inputSearch && formErrors.inputSearch[0]}
          />
        )}
        {formData[FormInputFilterEvent.filterSearch] === 'itemLabel' && (
          <InputText
            name="inputSearch"
            label="Id do Ingresso"
            placeholder={'Digite o id'}
            value={formData[FormInputFilterEvent.inputSearch]}
            onChange={e => onChangeFormInput(FormInputFilterEvent.inputSearch)(e.target.value)}
            error={formErrors.inputSearch && formErrors.inputSearch[0]}
          />
        )}
      </Form>
    </div>
  );
};
